;(function () {
  angular
    .module('contrast.application.dashboard')
    .controller(
      'SuppressFromExclusionCtrl',
      function (
        $scope,
        $uibModalInstance,
        logger,
        ApplicationFactory,
        ErrorService,
        appId,
        totalEvents,
        exclusionId
      ) {
        'ngInject'

        angular.extend($scope, {
          total_events: totalEvents
        })

        angular.extend($scope, {
          suppress: _suppress,
          cancel: _cancel
        })

        function _suppress() {
          ApplicationFactory.suppressEventsByExclusion(appId, exclusionId).then(
            function (response) {
              logger.logSuccess(response.data.messages[0])
              $uibModalInstance.close()
            },
            function (response) {
              ErrorService.processError(response)
              $uibModalInstance.close()
            }
          )
        }

        function _cancel() {
          $uibModalInstance.dismiss('cancel')
        }
      }
    )
})()
